module.exports = __webpack_public_path__ + "img/card_grade_input.30dc0b91.png";